/** ISO date-only string for OrderConfirmSheet prefill. */
export function celebrationDateOnly(date: string | null | undefined): string | undefined {
  if (!date) return undefined;
  const match = date.match(/^(\d{4}-\d{2}-\d{2})/);
  return match?.[1];
}

const CONFIRM_OCCASIONS = new Set([
  "birthday",
  "work_anniversary",
  "welcome",
  "farewell",
  "milestone",
  "thank_you",
  "congratulations",
  "just_because",
  "other",
]);

/** Map DB / brief occasion values to OrderConfirmSheet select options. */
export function normalizeOccasionForConfirm(occasion: string | undefined): string {
  const raw = (occasion ?? "other").trim().toLowerCase();
  if (CONFIRM_OCCASIONS.has(raw)) return raw;
  if (raw === "anniversary") return "work_anniversary";
  if (raw === "first day" || raw === "first_day") return "welcome";
  return "other";
}

/** Recipient card note placeholder matched to the celebration occasion. */
export function cardNotePlaceholder(
  occasion: string | undefined,
  recipientFirstName: string,
): string {
  const name = recipientFirstName.trim();
  const kind = normalizeOccasionForConfirm(occasion);

  switch (kind) {
    case "work_anniversary":
      return name
        ? `Congratulations on your work anniversary, ${name}! Thanks for everything you bring to the team.`
        : "Congratulations on your work anniversary! Thanks for everything you bring to the team.";
    case "welcome":
      return name
        ? `Welcome to the team, ${name}! We're so glad you're here.`
        : "Welcome to the team! We're so glad you're here.";
    case "farewell":
      return name
        ? `All the best, ${name}, you'll be missed!`
        : "All the best, you'll be missed!";
    case "milestone":
      return name
        ? `Congratulations, ${name}! What a milestone.`
        : "Congratulations! What a milestone.";
    case "thank_you":
      return name ? `Thank you, ${name}!` : "Thank you!";
    case "congratulations":
      return name ? `Congratulations, ${name}!` : "Congratulations!";
    case "just_because":
      return name ? `Thinking of you, ${name}.` : "Thinking of you.";
    case "birthday":
    default:
      return name
        ? `Happy birthday, ${name}! Thanks for everything this year.`
        : "Happy birthday! Thanks for everything this year.";
  }
}
